<template><div><code-well-header>
  <div class="d-w332">
    <dt-description-list
      gap="400"
      :items="items"
      direction="row"
    />
  </div>
</code-well-header>
<h2 id="variants-and-examples" tabindex="-1" class="d-docsite--header-2">Variants and Examples <a class="header-anchor d-link d-docsite--link d-link" href="#variants-and-examples" aria-hidden="true">#</a></h2>
<h3 id="default" tabindex="-1" class="d-docsite--header-3">Default <a class="header-anchor d-link d-docsite--link d-link" href="#default" aria-hidden="true">#</a></h3>
<code-well-header>
  <div class="d-w332">
    <dt-description-list
      ref="exampleDefault"
      gap="400"
      :items="items"
      direction="row"
    />
  </div>
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.exampleDefault"
vueCode='
<dt-description-list
  ref="descriptionList"
  gap="400"
  :items="items"
  direction="row"
/>
'
/>
<h3 id="column-direction" tabindex="-1" class="d-docsite--header-3">Column Direction <a class="header-anchor d-link d-docsite--link d-link" href="#column-direction" aria-hidden="true">#</a></h3>
<code-well-header>
  <div class="d-w332">
    <dt-description-list
      ref="exampleColumn"
      gap="400"
      :items="items"
      direction="column"
    />
  </div>
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.exampleColumn"
vueCode='
<dt-description-list
  gap="400"
  :items="items"
  direction="column"
/>
'
/>
<h3 id="long-text" tabindex="-1" class="d-docsite--header-3">Long Text <a class="header-anchor d-link d-docsite--link d-link" href="#long-text" aria-hidden="true">#</a></h3>
<code-well-header>
  <div class="d-w332">
    <dt-description-list
      ref="exampleLongText"
      gap="400"
      :items="longTextItems"
      direction="row"
    />
  </div>
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.exampleLongText"
vueCode='
<dt-description-list
  gap="400"
  :items="longTextItems"
  direction="row"
/>
'
/>
<h3 id="with-term-and-description-styles" tabindex="-1" class="d-docsite--header-3">With Term and Description Styles <a class="header-anchor d-link d-docsite--link d-link" href="#with-term-and-description-styles" aria-hidden="true">#</a></h3>
<code-well-header>
  <div class="d-w332">
    <dt-description-list
      ref="exampleWithStyles"
      gap="400"
      :items="items"
      direction="row"
      :termClass="[`d-fc-critical`, `d-fw-bold`]"
      :descriptionClass="[`d-fc-success`]"
    />
  </div>
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.exampleWithStyles"
vueCode='
<dt-description-list
  ref="exampleWithStyles"
  gap="400"
  :items="items"
  direction="row"
  :termClass="[`d-fc-critical`, `d-fw-bold`]"
  :descriptionClass="[`d-fc-success`]"
/>
'
/>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="descriptionlist" /></div></template>


<script setup>
const items = [
  {
    term: 'Local time',
    description: '10:36 AM (PST)',
  },
  {
    term: 'Dialpad',
    description: '(985) 241-8617',
  },
  {
    term: 'work',
    description: '+1 604-900-7909',
  },
  {
    term: 'email',
    description: 'jackeline.na@dialpad.com',
  },
];

const longTextItems = [
  {
    term: 'Customer Intent',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit,
    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
  },
  {
    term: 'Three word term',
    description: ` Duis aute irure dolor in reprehenderit in voluptate velit
    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
    cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
  },
];
</script>